import { Box, Stack } from '@mui/material';
import React from 'react';
import CusPassword from './CusPassword';
import CusItemTooltip from './CusItemTooltip';
import CusButton from './CusButton';
import { IconRefresh } from '@tabler/icons-react';
import useColor from '../../hooks/site/useColor';
import { API_USERS } from '../../api/users';
import IconGenItem from './IconGenItem';

export default function CusPassWitchGen({ password, setPassword, autoFocus, genParam = {} }) {
  const { primary } = useColor();

  const generatePassword = () => {
    API_USERS.info.pas
      .gen(genParam)
      .then((e) => {
        const newPassword = e.data.data;
        setPassword(newPassword);
      })
      .catch(console.error);
  };

  return (
    <Stack direction={'row'} width={'100%'} alignItems={'end'} gap={1}>
      <Box flex={1}>
        <CusPassword
          autoFocus={autoFocus}
          label={'New password'}
          isCopyClick
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
        />
      </Box>
      <Box>
        <IconGenItem
          onGenerate={generatePassword}
          tooltipText={'Auto generation of new password'}
        />
      </Box>
    </Stack>
  );
}
